module.exports = __webpack_public_path__ + "img/jing.bb662b11.png";